import { Action } from 'redux';

import portfoliosReducer from './portfolios';
import membersReducer from './members';
import groupsReducer from './groups';
import EnterpriseAdminDetails from '@/types/enterprise-admin-details';

export default (state: EnterpriseAdminDetails, action: Action): EnterpriseAdminDetails => {
  if (state === null) {
    return null;
  }

  return {
    ...state,
    ...portfoliosReducer(membersReducer(groupsReducer(state, action), action), action),
  };
};
